export const PARAPLANNING_TASK_OPTIONS = [
  {
    value: "downloaded_and_uploaded_documents",
    label: "Downloaded and uploaded documents",
  },
  {
    value: "sorting_case",
    label: "Sorting case",
  },
  {
    value: "created_manual_entry",
    label: "Created manual entry",
  },
  {
    value: "created_clients_on_finplan",
    label: "Created clients on finplan",
  },
  {
    value: "completed_fact_find",
    label: "Completed fact find",
  },
  {
    value: "created_comparison_report",
    label: "Created comparison report",
  },
  {
    value: "wrote_suitability_letter",
    label: "Wrote suitability letter",
  },
  {
    value: "wrote_demands_and_needs_letter",
    label: "Wrote demands and needs letter",
  },
  {
    value: "went_through_bank_statements_and_income",
    label: "Went through bank statements and income",
  },
  {
    value: "worked_out_debt_consolidation",
    label: "Worked out debt consolidation",
  },
  {
    value: "sent_email_to_adviser",
    label: "Sent email to adviser",
  },
  {
    value: "wrote_review_letter",
    label: "Wrote review letter",
  },
  {
    value: "finished_case",
    label: "Finished case",
  },
  {
    value: "set_commission",
    label: "Set commission",
  },
  {
    value: "updated_case",
    label: "Updated case",
  },
];
